import anuujin from "../../images/BoardMembers/Anuujin.jpg";
import anuujinC from "../../images/BoardMembers/AnuujinC.jpg";
import batsuuri from "../../images/BoardMembers/Batsuuri.png";
import bayartsogt from "../../images/BoardMembers/Bayartsogt.jpg";
import bilguun from "../../images/BoardMembers/Bilguun.png";
import james from "../../images/BoardMembers/James.JPG";
import matthew from "../../images/BoardMembers/Matthew.jpg";
import saruul from "../../images/BoardMembers/Saruul-Erdene.JPEG";
import selenge from "../../images/BoardMembers/Sissi.jpg";

export const boardMembers = [
    {
        name: "Anuujin Ider",
        role: "President",
        image: anuujin,
        linkedIn: "https://www.linkedin.com/in/anuujini/",
    },
    {
        name: "Saruul-Erdene Ganbayar",
        role: "Vice President",
        image: saruul,
        linkedIn: "https://www.linkedin.com/in/saruul-erdene/",
    },
    {
        name: "Selenge Ulam-Urnukh",
        role: "Creative Director",
        image: selenge,
        linkedIn: "https://www.linkedin.com/in/selengeuo/",
    },
    {
        name: "James Kitticha Edwards",
        role: "Web Developer",
        image: james,
        linkedIn: "https://www.linkedin.com/in/jkedwards8/",
    },
    {
        name: "Matthew Balgan",
        role: "Web Developer",
        image: matthew,
        linkedIn: "https://www.linkedin.com/in/matthewbalgan/",
    },
    {
        name: "Bayartsogt Yadamsuren",
        role: "Web Developer",
        image: bayartsogt,
        linkedIn: "https://www.linkedin.com/in/bayartsogt-yadamsuren/",
    },
    {
        name: "Batsuuri Baatarchuluun",
        role: "Treasurer",
        image: batsuuri,
        linkedIn: "https://www.linkedin.com/in/batsuuri7/",
    },
    {
        name: "Bilguun Enkhbileg",
        role: "Events Manager",
        image: bilguun,
        linkedIn: "https://www.linkedin.com/in/bilguunenkhb03/",
    },
    {
        name: "Anuujin Chadraa",
        role: "Public Relations Manager",
        image: anuujinC,
        linkedIn: "https://www.linkedin.com/in/anuujinc/",
    },
];
